export const NEW_INSTALLMENT_APPLICATION_URL = 'new';

export const NEW_PAY_IN_THREE_INSTALLMENT_APPLICATION_URL = 'newPayInThree';

export const MIN_EXTRAORDINARY_PAYMENT_AMOUNT = 10000;

export const MIN_EARLY_PAYMENT_AMOUNT = 10000;
